export default function classifyTargets(sharingValues) {
  if (sharingValues && sharingValues.length > 0) {
    const emails = sharingValues.filter(t => t.type === 'email').map(t => t.value);
    const userIds = sharingValues.filter(t => t.type === 'user').map(t => t.value);
    const teamIds = sharingValues.filter(t => t.type === 'team').map(t => t.value);
    const departmentIds = sharingValues.filter(t => t.type === 'department').map(t => t.value);
    return {emails, userIds, teamIds, departmentIds};
  }
  return {emails: [], userIds: [], teamIds: [], departmentIds: []};
}
